import { fonts } from './fonts';
import { getSpacing } from './getSpacing';
const MENU_WIDTH_UNITS = 14;
export const menuStyles = (theme) => ({
    '&:hover': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
    },
    '&:focus': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
    },
    '&:last-child': {
        borderBottom: 0,
    },
});
export const menuItemStyles = (theme) => (Object.assign(Object.assign({}, fonts.button), { paddingLeft: theme.spacing(3), paddingTop: '11px', paddingBottom: '11px', minWidth: getSpacing(theme, 1) * MENU_WIDTH_UNITS, height: '100%', minHeight: 0, display: 'block', color: theme.palette.primary.main, '&:hover': {
        color: `${theme.palette.primary.contrastText}`,
        backgroundColor: `${theme.palette.primary.main} !important`,
    }, '&:focus': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
    }, '&:active': {
        color: theme.palette.primary.contrastText,
        backgroundColor: `${theme.palette.grey[800]} !important`,
    }, boxSizing: 'content-box' }));
//# sourceMappingURL=menu.js.map